import { Box } from '@mui/material';
import { BarElement, CategoryScale, ChartDataset, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import { DashFormatValue, DashLabels, DashValueFormat } from 'views/dashboard/components/Charts';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export type DashVBarDataset = ChartDataset<"bar", number[]>[];

interface IProps {
    datasets: DashVBarDataset;
    labels: DashLabels[];
    tooltips?: string[];
    height?: number | string;
    width?: number | string;
    axisYStep?: number;
    enableTooltip?: boolean;
    valueFormat?: DashValueFormat;
    currrencySymbol?: string;
    onClickDrillDown?: (index: number) => void;
}

export const DashVBar: React.FC<IProps> = ({ height = 300, width = "100%", enableTooltip = true, axisYStep, valueFormat = "number", currrencySymbol, datasets, labels, tooltips, onClickDrillDown }) => {
    return (
        <Box>
            <Bar
                height={height}
                width={width}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    onClick: (e, elements) => {
                        if (elements.length > 0) {
                            const index = elements[0].index;
                            if (onClickDrillDown) onClickDrillDown(index);
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        },
                        datalabels: {
                            display: false,

                        },
                        tooltip: {
                            enabled: enableTooltip,
                            callbacks: {
                                title: function (item: any) {
                                    return tooltips ? tooltips[item[0].dataIndex] : labels[item[0].dataIndex].longLabel;
                                },
                                label: (context) => {
                                    return context.formattedValue;
                                }
                            }
                        },
                    },
                    scales: {
                        x: {
                            stacked: true
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                stepSize: axisYStep,
                                callback: (value, index, tick) => {
                                    return typeof (value) == "string"
                                        ? value
                                        : DashFormatValue(value, valueFormat, currrencySymbol);
                                }
                            }
                        }
                    }
                }}
                data={{
                    datasets,
                    labels: labels.map(p => p.shortLabel)
                }}
            />
        </Box>
    );
};
